module.exports = __webpack_public_path__ + "static/media/pulverizador_leque.5cc0e99e.png";